import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

//MUI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import AccountChartsTable from "./components/AccountChartsTable";
import { useAccountCharts } from "Context/AccountCharts";

export function AccountCharts() {
  const navigate = useNavigate();
  const { fetchAccountCharts, accountCharts } = useAccountCharts();

  useEffect(() => {
    const asyncInitAccountCharts = async () => {
      await fetchAccountCharts();
    };
    if (accountCharts.length === 0) {
      asyncInitAccountCharts();
    }
  }, []);

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "1.0rem",
              }}
            >
              <Typography variant="h5">Kontoplan</Typography>
              <Button
                onClick={() => navigate("create")}
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
              >
                SKAPA NY
              </Button>
            </Box>
            <AccountChartsTable />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
